// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Per-register-type expansion offsets for MODBUS bank matrices.
 *
 * The MODBUS bank matrix has one column per register space (COIL,
 * Discrete Input, Holding Register, Input Register). Each column needs
 * a starting register address (`*_initial`) and a per-lift stride
 * (`*_delta`). At bank expansion time the runtime computes
 *   `address_for_lift(N)` = initial + N * delta
 * for every read/write entry whose `units_based = true`.
 *
 * Fields default to 0 so adapters that never set offsets behave as
 * "no offset, no stride" — i.e. every lift reuses the entry's base
 * register address.
 */
export class ModbusRegisterOffsetMap implements flatbuffers.IUnpackableObject<ModbusRegisterOffsetMapT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModbusRegisterOffsetMap {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModbusRegisterOffsetMap(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusRegisterOffsetMap,
  ): ModbusRegisterOffsetMap {
    return (obj || new ModbusRegisterOffsetMap()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsModbusRegisterOffsetMap(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusRegisterOffsetMap,
  ): ModbusRegisterOffsetMap {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModbusRegisterOffsetMap()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  coilInitial(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  coilDelta(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  diInitial(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  diDelta(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  hrInitial(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  hrDelta(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  irInitial(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  irDelta(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startModbusRegisterOffsetMap(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addCoilInitial(builder: flatbuffers.Builder, coilInitial: number) {
    builder.addFieldInt32(0, coilInitial, 0);
  }

  static addCoilDelta(builder: flatbuffers.Builder, coilDelta: number) {
    builder.addFieldInt32(1, coilDelta, 0);
  }

  static addDiInitial(builder: flatbuffers.Builder, diInitial: number) {
    builder.addFieldInt32(2, diInitial, 0);
  }

  static addDiDelta(builder: flatbuffers.Builder, diDelta: number) {
    builder.addFieldInt32(3, diDelta, 0);
  }

  static addHrInitial(builder: flatbuffers.Builder, hrInitial: number) {
    builder.addFieldInt32(4, hrInitial, 0);
  }

  static addHrDelta(builder: flatbuffers.Builder, hrDelta: number) {
    builder.addFieldInt32(5, hrDelta, 0);
  }

  static addIrInitial(builder: flatbuffers.Builder, irInitial: number) {
    builder.addFieldInt32(6, irInitial, 0);
  }

  static addIrDelta(builder: flatbuffers.Builder, irDelta: number) {
    builder.addFieldInt32(7, irDelta, 0);
  }

  static endModbusRegisterOffsetMap(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createModbusRegisterOffsetMap(
    builder: flatbuffers.Builder,
    coilInitial: number,
    coilDelta: number,
    diInitial: number,
    diDelta: number,
    hrInitial: number,
    hrDelta: number,
    irInitial: number,
    irDelta: number,
  ): flatbuffers.Offset {
    ModbusRegisterOffsetMap.startModbusRegisterOffsetMap(builder);
    ModbusRegisterOffsetMap.addCoilInitial(builder, coilInitial);
    ModbusRegisterOffsetMap.addCoilDelta(builder, coilDelta);
    ModbusRegisterOffsetMap.addDiInitial(builder, diInitial);
    ModbusRegisterOffsetMap.addDiDelta(builder, diDelta);
    ModbusRegisterOffsetMap.addHrInitial(builder, hrInitial);
    ModbusRegisterOffsetMap.addHrDelta(builder, hrDelta);
    ModbusRegisterOffsetMap.addIrInitial(builder, irInitial);
    ModbusRegisterOffsetMap.addIrDelta(builder, irDelta);
    return ModbusRegisterOffsetMap.endModbusRegisterOffsetMap(builder);
  }

  unpack(): ModbusRegisterOffsetMapT {
    return new ModbusRegisterOffsetMapT(
      this.coilInitial(),
      this.coilDelta(),
      this.diInitial(),
      this.diDelta(),
      this.hrInitial(),
      this.hrDelta(),
      this.irInitial(),
      this.irDelta(),
    );
  }

  unpackTo(_o: ModbusRegisterOffsetMapT): void {
    _o.coilInitial = this.coilInitial();
    _o.coilDelta = this.coilDelta();
    _o.diInitial = this.diInitial();
    _o.diDelta = this.diDelta();
    _o.hrInitial = this.hrInitial();
    _o.hrDelta = this.hrDelta();
    _o.irInitial = this.irInitial();
    _o.irDelta = this.irDelta();
  }

  unpackFields(...fields: string[]): ModbusRegisterOffsetMapT {
    const t = new ModbusRegisterOffsetMapT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("coil_initial")) {
      t.coilInitial = this.coilInitial();
    }
    if (fieldSet.has("coil_delta")) {
      t.coilDelta = this.coilDelta();
    }
    if (fieldSet.has("di_initial")) {
      t.diInitial = this.diInitial();
    }
    if (fieldSet.has("di_delta")) {
      t.diDelta = this.diDelta();
    }
    if (fieldSet.has("hr_initial")) {
      t.hrInitial = this.hrInitial();
    }
    if (fieldSet.has("hr_delta")) {
      t.hrDelta = this.hrDelta();
    }
    if (fieldSet.has("ir_initial")) {
      t.irInitial = this.irInitial();
    }
    if (fieldSet.has("ir_delta")) {
      t.irDelta = this.irDelta();
    }
    return t;
  }
}

export class ModbusRegisterOffsetMapT implements flatbuffers.IGeneratedObject {
  constructor(
    public coilInitial: number = 0,
    public coilDelta: number = 0,
    public diInitial: number = 0,
    public diDelta: number = 0,
    public hrInitial: number = 0,
    public hrDelta: number = 0,
    public irInitial: number = 0,
    public irDelta: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ModbusRegisterOffsetMap.createModbusRegisterOffsetMap(
      builder,
      this.coilInitial,
      this.coilDelta,
      this.diInitial,
      this.diDelta,
      this.hrInitial,
      this.hrDelta,
      this.irInitial,
      this.irDelta,
    );
  }

  clone(): ModbusRegisterOffsetMapT {
    const obj = new ModbusRegisterOffsetMapT();
    obj.coilInitial = this.coilInitial;
    obj.coilDelta = this.coilDelta;
    obj.diInitial = this.diInitial;
    obj.diDelta = this.diDelta;
    obj.hrInitial = this.hrInitial;
    obj.hrDelta = this.hrDelta;
    obj.irInitial = this.irInitial;
    obj.irDelta = this.irDelta;
    return obj;
  }

  equals(other: ModbusRegisterOffsetMapT): boolean {
    if (this.coilInitial !== other.coilInitial) return false;
    if (this.coilDelta !== other.coilDelta) return false;
    if (this.diInitial !== other.diInitial) return false;
    if (this.diDelta !== other.diDelta) return false;
    if (this.hrInitial !== other.hrInitial) return false;
    if (this.hrDelta !== other.hrDelta) return false;
    if (this.irInitial !== other.irInitial) return false;
    if (this.irDelta !== other.irDelta) return false;
    return true;
  }
}

export function verifyModbusRegisterOffsetMap(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
  } finally {
    verifier.popDepth();
  }
}
